/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import {
    SelectOrCreateEntityRole,
    SelectOrCreateEntityRoleProps
} from 'src/luis/verticals/labelingSidePane/components/SelectOrCreateEntityRole';

export type RoleBasedEntityAdvancedOptionsProps = SelectOrCreateEntityRoleProps;

/**
 * Renders advanced options for a role-based entity.
 * Regex and prebuilt entities for now.
 */
export const RoleBasedEntityAdvancedOptions = React.memo((props: RoleBasedEntityAdvancedOptionsProps) => (
    <SelectOrCreateEntityRole {...props} />
));
